<div class="action-column flex-row flex-g-s" id="action-column">
  <ng-container *ngFor="let action of actions">
    <div matTooltip="{{action.toolTip}}">
      <a (click)="onClick(action.actionEvent)" [class.disable_icon]="action.disabled" [queryParams]="action.queryParams" [routerLink]="action.routerLink" mat-icon-button>
        <i [ngClass]="(action.iconStyle ?? this.defaultIconStyle) + ' ' + action.icon + ' ' + (action.actionClass ? action.actionClass : 'action-icon')"></i>
      </a>
    </div>
  </ng-container>
</div>
